import style from './Transcript.module.scss';
import { Conversation } from './TranscriptContent';

export interface TranscriptContentItemProps {
  conversation: Conversation;
}

const TranscriptContentItem = ({ conversation }: TranscriptContentItemProps) => {
  const wordsToHighlight = conversation.metadata.highlight;

  const highlightText = (text: string, wordsToHighlight: string[]) => {
    const parts = text.split(new RegExp(`(${wordsToHighlight.join('|')})`, 'g'));

    return parts?.map((part, index) => {
      if (wordsToHighlight.includes(part)) {
        return (
          <span
            key={index}
            className={style.highlight}
          >
            {part}
          </span>
        );
      } else {
        return part;
      }
    });
  };

  return (
    <div className={style.transcript__content__list__item}>
      {highlightText(conversation.words, wordsToHighlight)}
    </div>
  );
};

export default TranscriptContentItem;
